<template>
  <div>
    <DefaultNotificationAtendimento
    v-if="isOpen"
    @update-card="updateCard"
    @openCard="$emit('openCard', $event)"
    @close-notification="closeNotification"
    @toggle-today="toggleToday"
    @toggle-order="toggleOrder"
    @start-loading="startLoading"
    @stop-loading="stopLoading"
      :title="notification.title"
      :expand-text="notification.expandText"
      :notificationSwitch="true"
      :cards="conversations"
      :viewedCards="viewedConversations"
    />
  </div>
</template>

<script>
import DefaultNotificationAtendimento from '@/components/UI/notificacao/NotificacaoAtendimentoPadrao.vue'
import NotificationsAtendimentoRepository from '@/shared/http/repositories/crm/notificationsatendimento.js'

export default {
  components: {
    DefaultNotificationAtendimento
  },
  mounted () {
    this.retrieveNotifications()
  },
  data () {
    return {
      notification:
      {
        title: 'Atendimento',
        expandText: 'Visualizados'
      },
      conversations: [],
      viewedConversations: [],
      data: [],
      isOpen: true,
      today: false,
      asc: true,
      isLoading: false
    }
  },
  methods: {
    closeNotification () {
      this.isOpen = false
    },
    formatDate (value) {
      const date = new Date(value)
      return `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`
    },
    retrieveNotifications () {
      this.startLoading()
      this.getViewed()
      this.getNotViewed()
    },
    getViewed () {
      let filteredData = []
      let order = this.asc ? 'asc' : 'desc'
      let params = `visualizado=true&sort=dataNotificiacao,${order}`
      NotificationsAtendimentoRepository.searchNotificationsUserCustom(params)
        .then(response => {
          if (response.data) {
            this.data = response.data.content
            this.data.forEach(element => {
              let conversation = {
                cardIcon: 'fas fa-headset',
                cardIconText: this.formatDate(element.dataNotificiacao),
                cardTitle: element.conversation.name.nome,
                cardDescription: element.conversation.lastMessage.text ? element.conversation.lastMessage.text : 'Sem mensagens',
                cardChecked: element.visualizado,
                cardObj: element
              }
              filteredData.push(conversation)
            })
          }
          this.viewedConversations = filteredData
        })
        .catch(this.onException)
        .finally(() => this.stopLoading()) // Parar o carregamento quando a requisição terminar
    },
    getNotViewed () {
      let filteredData = []
      let order = this.asc ? 'asc' : 'desc'
      let params = `visualizado=false&sort=dataNotificiacao,${order}`
      NotificationsAtendimentoRepository.searchNotificationsUserCustom(params)
        .then(response => {
          if (response.data) {
            this.data = response.data.content
            this.data.forEach(element => {
              let conversation = {
                cardIcon: 'fas fa-headset',
                cardIconText: this.formatDate(element.dataNotificiacao),
                cardTitle: element.conversation.name.nome,
                cardDescription: element.conversation.lastMessage.text ? element.conversation.lastMessage.text : 'Sem mensagens',
                cardChecked: element.visualizado,
                cardObj: element
              }
              filteredData.push(conversation)
            })
          }
          this.conversations = filteredData
        })
        .catch(this.onException)
        .finally(() => this.stopLoading()) // Parar o carregamento quando a requisição terminar
    },
    updateCard (card) {
      this.retrieveNotifications()
    },
    toggleToday () {
      this.today = !this.today
      this.retrieveNotifications()
    },
    toggleOrder () {
      this.asc = !this.asc
      this.retrieveNotifications()
    },
    startLoading () {
      this.isLoading = true
    },
    stopLoading () {
      this.isLoading = false
    },
    onException (error) {
      console.error('Error:', error)
      this.stopLoading() // Parar o carregamento em caso de erro
    }
  },
  emits: ['update-card', 'close-notification', 'toggle-today', 'toggle-order']
}
</script>



// WEBPACK FOOTER //
// src/components/UI/notificacao/Atendimento.vue